import * as _ from 'underscore';
import React from 'react';
import ReactDom from 'react-dom';
import Select from 'react-select';
import Console from '../../../lib/debug';

export default class Drop extends React.Component {
    openDrop() {
        setTimeout(() => {
            document.body.classList.toggle('fixWindow', true);
            this.props.onOpen && this.props.onOpen();
        }, 10);
    }

    closeDrop() {
        document.body.classList.remove('fixWindow');
        this.node && this.node.select && this.node.select.closeMenu();
        this.props.disableButtons && this.props.disableButtons();
    }

    handleChange(...args) {
        this.props.onChange(...args);
        this.forceUpdateSelectorHeight();
        this.closeDrop();
    }

    onBlur() {
        this.node.onInputChange('');
    }

    focus() {
        this.node.select.focus();
    }

    blur() {
        this.node.onInputChange('');
    }

    /**
     * Force update selector height
     *
     * This fixes issues experienced in Chrome/Mac where the
     * React-Virtualized-Select's internal AutoSize Component does not update
     * until the element received a focus/blur event.
     * https://github.com/bvaughn/react-virtualized-select/issues/2
     * @return {any} null
     */
    forceUpdateSelectorHeight() {
        // eslint-disable-next-line react/no-find-dom-node
        const element = ReactDom.findDOMNode(this.node);
        if (element) {
            // eslint-disable-next-line no-undef
            element.style.height = window.getComputedStyle(element).height;
            setTimeout(() => {
                element.style.height = 'auto';
            }, 0);
        }
    }

    isOptionUnique(search) {
        let searchOption = search.option[search.labelKey].toLowerCase();
        let found = _.filter(search.options, item => {
            return (
                (item[search.labelKey] &&
                    item[search.labelKey].toLowerCase() === searchOption &&
                    item[search.labelKey] !== item[search.valueKey]) ||
                (item.keywords && item.keywords.indexOf(searchOption))
            );
        });

        return found.length === 0 && searchOption.length > 0;
    }

    onNewOptionClick = exercise => {
        this.closeDrop();
        this.props.onNewOptionClick(exercise);
    };

    render() {
        Console.render('designer.Drop');
        const value = this.props.value;
        const valueKey = this.props.valueKey;
        const labelKey = this.props.labelKey;
        const options = this.props.options;
        const filterOptions = this.props.filterOptions;
        const clearable = this.props.clearable;
        const placeholder = this.props.placeholder;
        const openOnFocus = this.props.openOnFocus;
        const autofocus = this.props.autofocus;
        const multi = this.props.multi;
        const promptTextCreator = this.props.promptTextCreator;
        const optionRenderer = this.props.optionRenderer;
        const arrowRenderer = this.props.arrowRenderer;
        const className = this.props.className || '';

        let errorClass = '';
        const errorMessage = this.props.errorMessage;
        const hasError = this.props.hasError;
        if (hasError) {
            errorClass = ' drop-error';
        }

        return (
            <div className={'th-drop ' + errorClass}>
                <Select.Creatable
                    value={value}
                    onNewOptionClick={this.onNewOptionClick.bind(this)}
                    valueKey={valueKey}
                    labelKey={labelKey}
                    optionRenderer={optionRenderer}
                    arrowRenderer={arrowRenderer}
                    options={options}
                    multi={multi}
                    isOptionUnique={this.isOptionUnique}
                    filterOptions={filterOptions}
                    promptTextCreator={promptTextCreator}
                    clearable={clearable}
                    placeholder={placeholder}
                    className={className}
                    openOnFocus={openOnFocus}
                    autoFocus={autofocus}
                    onOpen={this.openDrop.bind(this)}
                    onClose={this.closeDrop.bind(this)}
                    onBlur={this.onBlur.bind(this)}
                    ref={node => {
                        this.node = node;
                    }}
                    onChange={this.handleChange.bind(this)}
                />
                <span className="drop-error-message">{errorMessage}</span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/designer/components/Drop.jsx